// 404页面
import React, { Component } from 'react';

class NotFound extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <h1>Not Found Anything.</h1>
      </div>
    );
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/NotFound.js